// extracted by mini-css-extract-plugin
export default {"hooksMain":"styles_hooksMain__6kSfF"};